import { forwardRef } from 'react';

import { Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

const SlideLeftTransition = forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement<any, any>;
        },
        ref: React.Ref<unknown>
    ) => <Slide direction="left" ref={ref} {...props} />
);

export default SlideLeftTransition;
